import Form from "./Form";
// import './Contact.css';
function Contact(){
    return(
        <div className="contactUs">
            <div className="strip">
                <h1>Connect With <span>Our Expert</span></h1>
                <p>We'll get back to you real quick</p>
            </div>
            <div className="ourDetails">
                <div className="location">
                        <h1>Location:</h1>
                    <address>
                        <p>
                            <a href="https://maps.app.goo.gl/mmh2GRYhy2HbhFzPA">Flat no. 104, Harivillu Apartments, <br/>Near Tirupati Bus Stand, Tirupati.</a>
                        </p>
                    </address>
                </div>
                <div className="contactDetails">
                    <h1>Contact:</h1>
                    <div className="context">
                        <a href="tel:9700459609">+91-9700459606</a><br/>
                        <a href="tel:9391851610">+91-9391851610</a><br/>
                        <a href="mailto:bixianperformancemarketing@gmail.com">bixianperformancemarketing@gmail.com</a>
                    </div>
                </div>
                <div className="visitingHours">
                    <h1>Visiting Hours:</h1>
                    <div className="context">
                        <text>Mon - Sat :</text><br/>
                        <time> 10:00 AM to 06:00 PM</time>
                    </div>
                </div>
            </div>

            <div className="contact">
                <div className="form-body">
                    <Form/>
                </div>
                <div className="map">
                    <iframe title="bixian" src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d575.7145555358724!2d79.4298317536253!3d13.628729328931609!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1750828945916!5m2!1sen!2sin" width='100%' height='100%' allowfullscreen="true" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    {/* <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d575.7145555358724!2d79.4298317536253!3d13.628729328931609!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1750828945916!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
                </div>
            </div>
        </div>
    )
}
export default Contact;